export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-1200-3cbf9f9373a39ef6352971fd7fccc702.webp";